import React from 'react';
import {Col, Row, UiBox, UiContainer, UiIcon, UiText, UiTitle} from '~/components/elements/index';
import Banner from '~/pages/story/components/easeWebStory/Banner';
import Approach from '~/pages/story/components/easeWebStory/Approach';
import Exam1 from '~/pages/story/components/easeWebStory/Exam1';
import Result from '~/pages/story/components/easeWebStory/Result';
import '~/assets/css/main.css';
import {GrClose} from 'react-icons/gr';
import * as Scroll from 'react-scroll';
import {useMediaQuery} from '@chakra-ui/react';
import {QUERY_MOBILE} from '~/constants';

let Link = Scroll.Link;

interface Props {
  onClose: () => void;
}

const EaseWebStory = ({onClose}: Props) => {
  const [isDesktop] = useMediaQuery(`(min-width: ${QUERY_MOBILE})`, {ssr: false});

  return (
    <UiBox
      mt={{base: '0px', lg: '25px'}}
      className={'animate__animated animate__slideInUp animate__duration-1s'}
      pos="relative"
    >
      <UiContainer pos="sticky" top="85px" zIndex="1000" maxW="container.xl" w={{base: '100%', lg: '95%'}}>
        <Row justifyContent="flex-end">
          <Link to="easeWebBanner" smooth={true} hashSpy={true} offset={-100} duration={800} onClick={onClose}>
            <UiBox
              as={isDesktop ? Col : Row}
              alignItems="center"
              justifyContent="center"
              w={{base: '130px', lg: '70px'}}
              h={{base: '50', lg: '70px'}}
              borderRadius="3px"
              cursor="pointer"
              bgColor="white"
              mr={{base: '0px', lg: '10px'}}
            >
              {!isDesktop && <UiText color="black">Close</UiText>}
              <UiIcon as={GrClose} width="30px" height="30px" />
              {isDesktop && <UiText>Close</UiText>}
            </UiBox>
          </Link>
        </Row>
      </UiContainer>
      <UiContainer
        maxW="container.xl"
        w={{base: '100%', lg: '95%'}}
        top="0px"
        left="0"
        right="0"
        ml="auto"
        marginRight="auto"
        pos={{base: 'relative', lg: 'absolute'}}
      >
        <Col textAlign="center">
          <UiText fontSize={{base: 'xs', lg: 'xl'}}>UNIQUE HEALTHCARE SHOPPER EXPERIENCE ON WOOCOMMERCE</UiText>
          <UiTitle fontSize={{base: 'lg', lg: '5xl'}} fontWeight="400" mb="30px">
            Features and UX to stand out in competitive market
          </UiTitle>
        </Col>
      </UiContainer>
      <Banner />
      <Approach />
      <Exam1 />
      <Result />
    </UiBox>
  );
};

export default EaseWebStory;
